import { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";
import Zoom from "@mui/material/Zoom";
import LoadingOverlay from "../overlays/LoadingOverlay";
import { inviteAFriend } from "../../api/inviteAFriend";
import {
  commonErrorToastMessage,
  commonSuccessToastMessage,
} from "../toastify/AllToastifyErrors";
import ReCAPTCHA from "react-google-recaptcha";

const SITE_KEY ='6LfB128pAAAAACbcuiJudHbXr7mbveD8tTRIKQyM';

const InviteAFriendModal = ({ open, onClose, onSubmit }) => {

  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaValue , setRecaptchaValue] = useState('');
  
  // State variable to hold an array of emails
  const [emails, setEmails] = useState([""]);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

 // detect URLs/domains (http(s), //, www, domain.tld, IP)
  const containsUrl = (text) => {
    if (!text) return false;
    const s = String(text).trim();
    const urlRegex = /(?:https?:\/\/|\/\/|www\.|[A-Za-z0-9-]{1,63}\.[A-Za-z]{2,24}|\b\d{1,3}(?:\.\d{1,3}){3}\b|http%3a|https%3a)/i;
    return urlRegex.test(s);
  };

  // detect <script> tags, javascript: and inline event handlers or encoded script
  const containsScript = (text) => {
    if (!text) return false;
    const s = String(text);
    const scriptRegex = /<\s*script\b|javascript:|on\w+\s*=/i;
    const encodedScriptRegex = /%3C\s*script|javascript%3A/i;
    return scriptRegex.test(s) || encodedScriptRegex.test(s);
  };
  
  const handleEmailChange = (index, email) => {
    const updatedEmails = [...emails];
    updatedEmails[index] = email;
    setEmails(updatedEmails);
  };

  useEffect(() => {
    if (open) {
      setEmails([""]);
      setMessage("");
    }
  }, [open]);


  const removeEmailInput = (index) => {
    const updatedEmails = emails.filter((_, i) => i !== index);
    setEmails(updatedEmails);
  };

  const handleMessageChange = (e) => {
    const v = e.target.value;
    setMessage(v);
    if (containsScript(v)) {
      setErrorMessage("Message must not contain script tags or JavaScript.");
    } else if (containsUrl(v)) {
      setErrorMessage("Message must not contain links or domain names for security reasons.");
    } else {
      setErrorMessage("");
    }
  };

  const Captchalogic =value=>{
    console.log(value);
    setRecaptchaValue(value)
  }
  const handleInviteAFriendButton = async () => {
    try {
      setIsLoading(true);

       // Block if message contains URL (double-check before sending)
      if (message && (containsScript(message) || containsUrl(message))) {
        setIsLoading(false);
        const msg = containsScript(message)
          ? "Message contains script/JavaScript which is not allowed."
          : "Message contains links or domain names which are not allowed.";
        setErrorMessage(msg);
        commonErrorToastMessage(msg);
        return;
      }

      const username = localStorage.getItem("username");
      
      if (emails.length === 0 || emails.every((email) => email.trim() === "")) {
        setIsLoading(false);
        commonErrorToastMessage("Please enter at least one email");
        return;
      }

      const response = await inviteAFriend(username, emails, message , recaptchaValue);

      console.log("Invite a Friend Response : ", response);

      setIsLoading(false);
      commonSuccessToastMessage("Invitation sent successfully!");
      setEmails([""]);
      setMessage("");
      onClose();
    } catch (error) {
      console.log("error form invite a friend",error);
      if(error.response.status===403){
        commonErrorToastMessage("Your session has expired please log in again.");
        setIsLoading(false);
        onClose();
      }else{
      console.error("Error : ", error.response);
      setErrorMessage(error.response.data.success);
      setIsLoading(false);
      setEmails([""]);
      setMessage("");
      commonErrorToastMessage("Oops! Invitation send failed. Try again");
      onClose();
     }
    }
  };

  const handleModalClose = () => {
    setEmails([""]);
    setMessage("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="youtube-modal-title"
      className="flex place-content-center items-center fixed"
      BackdropProps={{
        style: { pointerEvents: "none" },
      }}
      disableEscapeKeyDown
    >
      <div className="bg-white shadow-lg text-[#212529] p-6 rounded-lg animate-fadeSlideDown transition-all ease-in-out duration-500  w-[35vw]">
        <div className="flex place-content-between border-b pb-5">
          <h2 className="text-lg font-semibold ">Invite Your Friends</h2>
          <Tooltip
            title="Close"
            arrow
            placement="top"
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
          >
            <button
              className="text-[#6c757d] text-lg hover:bg-[#edeeef] px-2 rounded-full "
              onClick={handleModalClose}
            >
              <i className="fa-solid fa-xmark"></i>{" "}
            </button>
          </Tooltip>
        </div>

        {emails.map((email, index) => (
          <div key={index} className="flex border-b py-3 ">
            <p>To: </p>
            <input
              type="email"
              placeholder="Enter email"
              value={email}
              onChange={(e) => handleEmailChange(index, e.target.value)}
              className="px-3 rounded-lg w-5/6 outline-none block "
            />
          </div>
        ))}

        <div className="pt-2 h-40 border-b">
          <textarea
            onChange={handleMessageChange}
            value={message}
            className={`w-full h-full resize-none bg-transparent outline-1 custom-scrollbar overflow-none p-2 `}
            placeholder="Add a message (optional)"
          ></textarea>
        </div>
        {errorMessage && (
          <p className="text-red-500 animate-fade-slide-down text-[13px] signup-error-message w-full border border-red-500  p-2  mb-3">
            {errorMessage}
          </p>
        )}
        {
          <div className="flex place-content-center" style={{ paddingTop: '10px' }}>
        <ReCAPTCHA sitekey={SITE_KEY} onChange={Captchalogic}  />
        </div>
      }
        <div className="flex place-content-center">
          <Tooltip
            title="Invite Your Friend"
            arrow
            placement="top"
            TransitionComponent={Zoom}
            TransitionProps={{ timeout: 300 }}
          >
            <button
              className="mt-4 px-6 py-2 bg-[#f4833d] text-white rounded hover-bg-[#e06a21] "
              onClick={handleInviteAFriendButton}
            >
              Invite
            </button>
          </Tooltip>
        </div>
        {isLoading && <LoadingOverlay />}
      </div>
    </Modal>
  );
};

export default InviteAFriendModal;
